import { Navigate } from "react-router-dom";
import { DecodedToken } from "../models/DecodedToken";
import { ReactElement } from "react";
import { decodeToken } from "../helperMethods/decodeToken";

export function RoleBasedRoute({ children }: { children: ReactElement }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" />;

  const pathname = window.location.pathname;

  try {
    const decoded: DecodedToken = decodeToken(token);
    const toBool = (val: any) => String(val).toLowerCase() === "true" || val === true;
    const isAdmin =
      toBool((decoded as any).isAdmin) ||
      String((decoded as any).role ?? "").toLowerCase() === "admin";
    const isEsimReseller = toBool((decoded as any).isEsimReseller);

    // Admin can access everything
    if (isAdmin) {
      return children;
    }

    // ✅ Reseller allowed routes
    const resellerAllowed = [
      "/",
      "/plans",
      "/help-support",
      "/pricing",
      "/sale/qr",
      "/topUpEsim",
      "/balance",
      "/topups",
      "/sales",
      "/credits",
      "/debits",
      "/clients",
      "/account/notifications",
      "/account/business-info"
    ];

    if (isEsimReseller) {
      if (resellerAllowed.includes(pathname) || pathname.startsWith("/package/")) {
        return children;
      }
    } else {
      if (
        [
          "/",
          "/pricing",
          "/help-support",
          "/assign-sim-package",
          "/balance",
          "/topups",
          "/sales",
          "/credits",
          "/debits",
          "/account/notifications",
          "/account/business-info"
        ].includes(pathname)
      ) {
        return children;
      }
    }

    console.log("[RBRoute] redirecting to / because not allowed");
    return <Navigate to="/" />;
  } catch (e) {
    console.log("[RBRoute] exception:", e);
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }
}
